import { render, staticRenderFns } from "./xinWenXiangQing.vue?vue&type=template&id=3434d270&scoped=true"
import script from "./xinWenXiangQing.vue?vue&type=script&lang=js"
export * from "./xinWenXiangQing.vue?vue&type=script&lang=js"
import style0 from "./xinWenXiangQing.vue?vue&type=style&index=0&id=3434d270&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3434d270",
  null
  
)

export default component.exports